import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import { isLoggedIn } from './utils/auth';
import { usePageViews, useClientID } from './utils/analyticsHooks';
import { useCookieConsent } from './utils/cookieConsent';

import EnterRoutes from './routes/Enter';
import ProfileRoutes from './routes/Profile';
import RedirectRoutes from './routes/h';
import PaymentRoutes from './routes/Payment';
import PromoRoutes from './routes/Promo';
import CookieBanner from './components/banners/CookieBanner';
import SetPasswordRoute from './routes/SetPassword';
import SubscriptionConfirmedRoute from './routes/Email/SubscriptionConfirmed';
import DiiaSuccessRoute from './routes/DiiaSuccessRoute';
import SignUpRoutes from './routes/sign-up';

const App = () => {
  useClientID();
  usePageViews();

  const { isCookieAllowed, onCookieConsentGiven } = useCookieConsent();

  return (
    <>
      <Switch>

        <Route path="/enter">
          <EnterRoutes />
        </Route>

        <Route path="/profile">
          <ProfileRoutes />
        </Route>

        <Route path="/h">
          <RedirectRoutes />
        </Route>

        <Route path="/payment">
          <PaymentRoutes />
        </Route>

        <Route path="/promo">
          <PromoRoutes />
        </Route>

        <Route path="/sign-up">
          <SignUpRoutes />
        </Route>

        <Route path="/set-password">
          <SetPasswordRoute />
        </Route>

        <Route path="/email/subscription-confirmed" exact>
          <SubscriptionConfirmedRoute />
        </Route>

        <Route path="/diia/success" exact>
          <DiiaSuccessRoute />
        </Route>

        <Route>
          <Redirect to={isLoggedIn() ? '/profile' : '/enter'} />
        </Route>

      </Switch>

      { !isCookieAllowed && (
        <CookieBanner onCookieConsent={onCookieConsentGiven} />
      )}

    </>
  );
};

export default App;
